import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import ThumbsUpIcon from '../../../icons/illustrative-secondary/ThumbsUpSecondary';
import Container from '../../../base/Grid/container';
import Link from '../../../base/Link';
import Typography from '../../../base/Typography';

export const ContainerStyled = styled(Container)`
  ${({ theme, formvariant }) => {
    if (formvariant === 'hero') {
      return css`
        margin-top: ${theme.mediumUp() ? rem(50) : rem(32)};
        margin-bottom: ${theme.mediumUp() ? rem(60) : rem(48)};
      `;
    }
    return false;
  }}
`;

export const IconStyled = styled(ThumbsUpIcon)`
  ${({ theme, formvariant }) => {
    let marginTop = 0;
    let iconWidth = rem(50);

    if (theme.mediumUp()) {
      marginTop = rem(-25);
    }

    if (formvariant === 'hero') {
      if (theme.xlargeUp()) {
        iconWidth = rem(60); // hero desktop icon width
      }
    }

    return css`
      width: ${iconWidth};
      margin-top: ${marginTop};
      margin-bottom: ${rem(10)};
    `;
  }}
`;

export const LinkStyled = styled(Link)`
  ${({ theme }) => css`
    color: ${theme.colors.neutral.white};
    text-decoration: underline;
    :hover,
    :active {
      color: ${theme.colors.neutral.gray80};
    }
  `}
`;

export const TypographyHeroConfirmationStyled = styled(Typography)`
  ${({ theme, formvariant }) => {
    let padding = `0 ${rem(30)} ${rem(5)}`;
    if (theme.xlargeUp()) {
      padding = 0;
    }

    return css`
      ${formvariant === 'hero' && `padding: ${padding}`};
      text-align: center;
    `;
  }}
`;
